import * as React from "react";
import {cx} from "emotion";

import "./filter-mode.scss";

import {cs}           from "@Common/react/chain-services";
import {defaultState} from "@Common/react/default-state";
import {scopedState}  from "@Common/react/scoped-state";
import {scnv}         from "@Common/react/state-change-nested-value";
import {UseState}     from "@Common/react/use-state";
import {mapValues}    from "@Common/utils/objects";

import {DesktopControlPanel} from "../common/desktop-control-panel/desktop-control-panel";
import {MobileControlPanel}  from "../common/mobile-control-panel/mobile-control-panel";

import {ColorPaletteSvg}                   from "./color-palette-svg";
import {formatColorToHex, parseHexToColor} from "./hex-color";
import {TintModal}                         from "./tint-modal/tint-modal";
import {YinYangSvg}                        from "./yin-yang-symbol-svg";

export const FilterMode = ({onDone, next}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => next({
        modObjects: (_) => !state.value ? _ : mapValues(_, (obj) => {
            if (!obj) {
                return null;
            }

            const filter = {
                ...state.value,
                strength: state.value.strength ?? .5,
            };
            return obj && ({
                ...obj,
                renderKey: {...obj.renderKey, filter},
                getColorC: (params) => obj.getColorC({
                    ...params,
                    filter,
                }),
            });
        }),
        modePanel: ({mobile, onCancel}) => (mobile ? MobileControlPanel : DesktopControlPanel)({
            onCancel,
            content: (
                <div {...{
                    className: cx("filter-mode-1s0 control-panel", {mobile}),
                    "xd-qa-type": "card",
                    "xd-qa-name": "Filter Mode",
                }}>
                    {[
                        {
                            type: "grayscale",
                            label: "Gray",
                            faIcon: "adjust",
                        },
                        {
                            type: "negative",
                            label: "Negative",
                            icon: YinYangSvg,
                        },
                    ].map(({type, label, icon, faIcon}) => (
                        <button {...{
                            key: type,
                            className: cx({active: state.value?.type === type, mobile}),
                            onClick: () => scnv(state, ["type"], (t) => t === type ? null : type),
                            "xd-qa-type": "button",
                            "xd-qa-name": label,
                        }}>
                            <div className="label">
                                {label}
                            </div>

                            <div className="icon">
                                {icon ? icon({}) : (
                                    <i className={"fa fa-" + faIcon}/>
                                )}
                            </div>
                        </button>
                    ))}

                    {cs(
                        ["tintModal", (_, next) => TintModal({
                            color: {
                                value: formatColorToHex(state.value?.color),
                                onChange: (c) => state.change((s) => ({
                                    ...s,
                                    type: c == null ? null : "tint",
                                    color: parseHexToColor(c),
                                })),
                            },
                            strength: defaultState(scopedState(state, ["strength"]), () => .5),
                            next,
                        })],
                        ({tintModal}) => (
                            <button {...{
                                className: cx({active: state.value?.type === "tint", mobile}),
                                onClick: (e) => {
                                    if (state.value?.type === "tint") {
                                        scnv(state, ["type"], () => null);
                                    } else {
                                        if (state.value?.color && state.value.type !== "tint") {
                                            scnv(state, ["type"], () => "tint");
                                        }
                                        tintModal.show(e.target, {direction: mobile ? "top" : "left"});
                                    }
                                },
                                "xd-qa-type": "button",
                                "xd-qa-name": "Tint",
                            }}>
                                <div className="label">
                                    Tint
                                </div>

                                <div className="icon">
                                    {ColorPaletteSvg()}
                                </div>
                            </button>
                        )
                    )}

                </div>
            ),
            onDone: () => onDone(state.value),
        }),
    }),
);
